import useSdsDownloadFile from '@behavior/chemicalProducts/useSdsDownloadFile';
import { useParams } from 'react-router';
import { Loading } from 'react-lib/dist/components-es';
import CustomPDFViewer from '../ChemicalProductDetails/GeneralInformation/CustomPDFViewer/CustomPDFViewer';
import styles from '../ChemicalProductDetails/GeneralInformation/CustomPDFViewer/CustomPDFViewer.module.scss';

const ChemicalProductSdsFileDownloadContainer = () => {
  const { id } = useParams<{ id: string }>();
  const { sdsFile, isLoading } = useSdsDownloadFile(id);

  if (isLoading) {
    return <Loading isLoading />;
  }

  const renderDocument = (file: any) => {
    const url = URL.createObjectURL(file.data);

    return (
      <div className={`rpv-core__viewer ${styles.modalContent} sdsFileContainer`}>
        <CustomPDFViewer fileUrl={url} />
      </div>
    );
  };

  return <div>{sdsFile && renderDocument(sdsFile)}</div>;
};

export default ChemicalProductSdsFileDownloadContainer;
